module.exports = __webpack_public_path__ + "media/emoji_icons/neutral_disabled-00e3b316.svg";